import React, { useCallback, useState } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { DEFAULT_LOGIN_LOGO_ALT, DEFAULT_LOGIN_LOGO_SRC } from './LoginLogo.constants';

const LoginLogo = ({ sx, logoUrl = null, alt = null }) => {
  const [hasError, setHasError] = useState(false);

  const onError = useCallback(() => setHasError(true), []);

  const src = logoUrl && !hasError ? logoUrl : DEFAULT_LOGIN_LOGO_SRC;

  return (
    <Box alt={alt || DEFAULT_LOGIN_LOGO_ALT} component="img" src={src} sx={sx} onError={onError} />
  );
};

LoginLogo.propTypes = {
  sx: PropTypes.object.isRequired,
  logoUrl: PropTypes.string,
  alt: PropTypes.string,
};

export default LoginLogo;
